import { ChildBasicInfoModel } from '@schemas/child/child-registration/child-basic-info';

export enum ChildRegistrationSteps {
  registrationForm = 1,
  childExtraInformationForm = 2,
  childBirthCertificateForm = 3,
  childCareGiverInformationForm = 4,
  childHealthInformationForm = 5,
  childCareGiverChildInformationForm = 6,
  childCareGiverExtraInformationForm = 7,
  childCareGiverContributionForm = 8,
  childEmergencyContactForm = 9,
  careGiverReferencePanelForm = 10,
}

export interface ChildRegistrationRouteState {
  step?: ChildRegistrationSteps;
  childId?: string;
  childDetails?: ChildBasicInfoModel;
  practitionerId?: string;
  isFromTraineeOnboarding?: boolean;
}
